import { categories } from "@/mocks/categories";
import { articles } from "@/mocks/articles";
import { Link } from "react-router-dom";

export default function CommunityStats() {
  return (
    <section className="py-14 md:py-20 bg-background-100/50">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left: Stats */}
          <div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-100 mb-6">
              为什么数百万人选择黑料社区？
            </h2>
            <div className="grid grid-cols-2 gap-4 mb-8">
              {[
                { icon: "ri-shield-check-line", title: "真实可靠", desc: "多层审核机制，确保内容真实性" },
                { icon: "ri-user-voice-line", title: "用户驱动", desc: "人人皆可爆料，真相来自民间" },
                { icon: "ri-eye-off-line", title: "匿名保护", desc: "严格保护爆料人隐私安全" },
                { icon: "ri-flashlight-line", title: "深度调查", desc: "专业团队深入挖掘内幕" },
              ].map((item) => (
                <div key={item.title} className="p-4 bg-background-100 rounded-lg">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 mb-3">
                    <i className={`${item.icon} text-primary-400 text-xl`}></i>
                  </div>
                  <h4 className="font-heading font-semibold text-foreground-200 mb-1">{item.title}</h4>
                  <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Hot Tags */}
          <div>
            <h3 className="font-heading font-bold text-xl text-foreground-200 mb-6">
              <i className="ri-hashtag text-accent-500 mr-2 w-5 h-5 inline-flex items-center justify-center align-middle"></i>
              热门话题
            </h3>
            <div className="flex flex-wrap gap-2 mb-8">
              {Array.from(new Set(articles.flatMap((a) => a.tags))).map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1.5 bg-background-100 text-foreground-400 hover:text-foreground-200 hover:bg-background-200 rounded-full text-xs font-medium transition-colors cursor-pointer border border-background-200/40"
                >
                  #{tag}
                </span>
              ))}
            </div>

            <h3 className="font-heading font-bold text-xl text-foreground-200 mb-4">
              <i className="ri-folder-2-line text-primary-500 mr-2 w-5 h-5 inline-flex items-center justify-center align-middle"></i>
              快速入口
            </h3>
            <div className="grid grid-cols-2 gap-3">
              {categories.slice(0, 4).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex items-center gap-3 p-3 bg-background-100 rounded-lg hover:ring-1 hover:ring-primary-500/20 transition-all cursor-pointer group"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors">
                    <i className={`${cat.icon} text-primary-400 text-lg`}></i>
                  </div>
                  <div>
                    <div className="text-sm font-medium text-foreground-200">{cat.name}</div>
                    <div className="text-xs text-foreground-600">{cat.articleCount} 篇文章</div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}